export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9aBB5nXwJxArepw.988186f6.woff2";